/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Type_Collects_NotesInputs */

const en_task_catalog_type_collects_notes = /** @type {(inputs: Task_Catalog_Type_Collects_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepts notes on completion`)
};

const pt_br2_task_catalog_type_collects_notes = /** @type {(inputs: Task_Catalog_Type_Collects_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceita observações ao concluir`)
};

/**
* | output |
* | --- |
* | "Accepts notes on completion" |
*
* @param {Task_Catalog_Type_Collects_NotesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_type_collects_notes = /** @type {((inputs?: Task_Catalog_Type_Collects_NotesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Type_Collects_NotesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_type_collects_notes(inputs)
	return pt_br2_task_catalog_type_collects_notes(inputs)
});